export default "__VITE_ASSET__CouoXSRU__"